import { QualityTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("qaqc_fibre_analysis")
export class QAQCFibreAnalysisEntity {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    @Column({
        name: "test_date",
        type: "datetime"
    })
    testDate: Date;

    @Column("varchar", {
        nullable: true,
        name: "work_order_no",
        length: 100
    })
    workOrderNo: string;

    @Column("varchar", {
        nullable: true,
        name: "lot_number",
        length: 255
    })
    lotNumber: string;

    @Column("varchar", {
        nullable: true,
        name: "operation",
        length: 100
    })
    operation: string;

    @Column("varchar", {
        nullable: true,
        name: "prev_operation",
        length: 100
    })
    prevOperation: string;

    @Column("varchar", {
        nullable: false,
        name: "product",
        length: 100
    })
    product: Number;
    
        @Column("enum", {
            enum : QualityTypeEnum,
            nullable: true,
            name: "quality"
        })
        quality: QualityTypeEnum;

        

    @Column("decimal", {
        nullable: true,
        precision: 10,
        scale: 2,
        name: "mean_length"
    })
    meanLength: number;

    @Column("decimal", {
        nullable: true,
        precision: 10,
        scale: 2,
        name: "shortest_fiber"
    })
    shortestFiber: number;

    @Column("decimal", {
        nullable: true,
        precision: 10,
        scale: 2,
        name: "longest_fiber"
    })
    longestFiber: number;

    @Column("decimal", {
        nullable: true,
        precision: 5,
        scale: 2,
        name: "short_fiber_percent"
    })
    shortFiberPercent: number;

    @Column("varchar", {
        nullable: true,
        name: "slub",
        length: 100
    })
    slub: string;

    @Column("decimal", {
        nullable: false,
        precision: 10,
        scale: 3,
        name: "quantity"
    })
    quantity: number;

    @Column("varchar", {
        nullable: true,
        name: "test_type",
        length: 50
    })
    testType: string;

    @Column("varchar", {
        nullable: true,
        name: "analysis_type",
        length: 50
    })
    analysisType: string;

    @Column("varchar", {
        nullable: true,
        name: "remarks",
        length: 500
    })
    remarks: string;
    @Column('boolean',{
        name:'is_qaqc_approved',
        default:false
    })
    isQAQCApproved : boolean
}


